import React, { useState } from 'react';

export interface Location {
  name: string;
  address: string;
  coordinates?: { lat: number; lng: number };
}

interface LocationPickerProps {
  onLocationSelect: (location: Location) => void;
  onClose: () => void;
  initialLocation?: Location;
}

const LocationPicker: React.FC<LocationPickerProps> = ({
  onLocationSelect,
  onClose,
  initialLocation,
}) => {
  const [locationName, setLocationName] = useState(initialLocation?.name || '');
  const [address, setAddress] = useState(initialLocation?.address || '');
  const [coordinates, setCoordinates] = useState<{ lat: number; lng: number } | undefined>(
    initialLocation?.coordinates
  );

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (locationName && address) {
      onLocationSelect({
        name: locationName,
        address: address,
        coordinates: coordinates,
      });
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">Locatie selecteren</h3>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700"
          aria-label="Sluiten"
        >
          ✕
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Locatienaam
          </label>
          <input
            type="text"
            value={locationName}
            onChange={(e) => setLocationName(e.target.value)}
            placeholder="Bijv. Restaurant De Gouden Leeuw"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Adres
          </label>
          <input
            type="text"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="Straat + huisnummer, stad"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Latitude (optioneel)
            </label>
            <input
              type="number"
              step="any"
              value={coordinates?.lat || ''}
              onChange={(e) =>
                setCoordinates({
                  lat: parseFloat(e.target.value) || 0,
                  lng: coordinates?.lng || 0,
                })
              }
              placeholder="52.3676"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Longitude (optioneel)
            </label>
            <input
              type="number"
              step="any"
              value={coordinates?.lng || ''}
              onChange={(e) =>
                setCoordinates({
                  lat: coordinates?.lat || 0,
                  lng: parseFloat(e.target.value) || 0,
                })
              }
              placeholder="4.9041"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        <div className="flex gap-2 pt-2">
          <button
            type="submit"
            className="flex-1 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md font-medium"
          >
            Locatie opslaan
          </button>
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Annuleren
          </button>
        </div>
      </form>
    </div>
  );
};

export default LocationPicker;
